import { useRef, useState } from "react";
import moment from "moment";
import { get } from "lodash";
import { DndProvider } from "react-dnd";
import { useMediaQuery } from "usehooks-ts";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { TouchBackend } from "react-dnd-touch-backend";
import { usePreview } from "react-dnd-preview";
import { HTML5Backend } from "react-dnd-html5-backend";
// Custom Components
import BurgerOnTray from "../../components/burgerOnTray";
import DisplayItem from "../../components/displayItem";
import PrimaryHeader from "../../components/primaryHeader";
import ReadyTray from "../../components/readyTray";
import TrayCard from "../../components/trayCard";
import OnboardingPopup from "../../components/onboardingPopups";
import ButtonPrimary from "../../components/buttonPrimary";
import {
  setEndTime,
  resetState,
  resetAll,
  setTimer,
  setStartTime,
} from "../../store/ingredient";
import t2 from "../../assets/images/tray/t2.svg";
import t3 from "../../assets/images/tray/t3.svg";
import t4 from "../../assets/images/tray/t4.svg";
import bunTop from "../../assets/images/ingredients/bun_top.svg";
import bunBottom from "../../assets/images/ingredients/bun_bottom.svg";
import cheeseMelt from "../../assets/images/ingredients/cheese_melt.svg";
import lettuce from "../../assets/images/ingredients/lettuce.svg";
import pattyUncooked from "../../assets/images/ingredients/patty_uncooked.svg";
import pattyCooked from "../../assets/images/ingredients/patty_cooked.svg";
import pattyOvercooked from "../../assets/images/ingredients/patty_overcooked.svg";
// Sound file
import gameMusic from "../../assets/sound/game.mp3";

// Images
import sauce from "../../assets/images/sauce.svg";

// Styles
import "./styles.scss";
const ingredArray = [
  { image: t2, name: "cheese" },
  { image: t3, name: "lettuce" },
  { image: t4, name: "bun" },
  { image: pattyUncooked, name: "patty" },
  { image: pattyUncooked, name: "pattyUnCooked" },
  { image: pattyCooked, name: "pattyCooked" },
  { image: pattyOvercooked, name: "pattyOverCooked" },
];

const DEMO_STEPS_DESC = [
  "Orders appear here! On the customer tray.",
  "This is the Burger Tray. You drag items here.",
  "This is the grill station. You drag Uncooked Patties here.",
  "This is Ingredients Tray.",
  "Drag the bun to the Burger Tray.",
  "Drag patty to Grill Station.",
  "Patty Cooks Perfectly in some seconds.",
  "If Patty Overcooks, Throw that to Trashcan..",
  "Add Cheese/Lettuce to the burger.",
  "Drag the Burger to the customer.",
];

const generatePreview = (type, item, style) => (
  <div style={style}>Generated</div>
);

const BurgerComponent = (props) => {
  return (
    <div className="burger-element col-12" style={{ zIndex: props.zIndex }}>
      {props.image && <img src={props.image} alt="" srcset="" />}
    </div>
  );
};
function Main(props) {
  const ingredients = useSelector(
    (state) => get(state, "ingredients"),
    shallowEqual
  );
  const isMobile = useMediaQuery("(max-width: 968px)");
  const isDemo = useSelector(
    (state) => get(state, "ingredients.isDemo", false),
    shallowEqual
  );

  const [demoStep, setDemoStep] = useState(0);
  const [isAudioMute, setIsAudioMute] = useState(true);
  const [playing, setPlaying] = useState(false);

  const AudioRef = useRef();

  const dispatch = useDispatch();

  const timer = get(ingredients, "timer");
  const served = get(ingredients, "served", 0);
  const points = get(ingredients, "points", 0);
  const startTime = get(ingredients, "startTime", 0);
  const burgerQueue = get(ingredients, "burgerQueue", []);
  const burgerTray = get(ingredients, "burgerTray", []);

  const burgerMap = (ingredient) => {
    switch (ingredient) {
      case "pattyCooked":
        return pattyCooked;
      case "pattyUnCooked":
        return pattyUncooked;
      case "pattyOverCooked":
        return pattyOvercooked;
      case "buntop":
        return bunTop;
      case "cheese":
        return cheeseMelt;
      case "lettuce":
        return lettuce;
      case "bunbottom":
        return bunBottom;
      default: return ""
    }
  };

  const MyPreview = () => {
    const preview = usePreview();
    if (!preview.display) {
      return null;
    }
    const { itemType, item, style } = preview;

    let itemImg = null;
    ingredArray.forEach((data) => {
      if (data.name === item.name) {
        itemImg = data.image;
      }
    });
    if (itemType === "burger") {
      itemImg = burgerTray[item.index].ingredients;
    }
    return (
      <div
        className="item-list__item"
        style={{ ...style, ...{ transition: "none" } }}
      >
        {itemType === "burger" ? (
          itemImg
            .map((item, index) => {
              return (
                <BurgerComponent
                  i={index}
                  key={index}
                  zIndex={(index + 1) * 100}
                  image={burgerMap(item)}
                />
              );
            })
            .reverse()
        ) : (
          <img src={itemImg} />
        )}
      </div>
    );
  };

  const playAudio = () => {
    setPlaying(true);
    const audioEl = document.getElementsByClassName("audio-hide")[0];
    audioEl.play();
  };
  const pauseAudio = () => {
    setPlaying(false);

    const audioEl = document.getElementsByClassName("audio-hide")[0];
    audioEl.pause();
  };

  // ALL ABOUT TUTORIAL --

  const finishTutorial = () => {
    setDemoStep(0);
    dispatch(setTimer(Date.now() + 300000));
    dispatch(setStartTime(moment()));
    dispatch(resetState());
    dispatch(resetAll({ isDemo: false }));
    // dispatch(setIsDemo({isDemo: '0'}));
  };

  return (
    // <div>
    //   {ingredients.isDemo.toString()}
    //   <button onClick={() => dispatch(setIsDemo({isDemo: ingredients.isDemo?'0':'1'}))}>Toggle</button>
    // </div>
    <section className="main-page-container bg-primary">
      <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
        <PrimaryHeader
          isAudioMute={isAudioMute}
          isDemo={isDemo}
          levelNumber={timer}
          startTime={startTime}
          closeHandler={() => {
            props.history.push("/score");

            dispatch(setEndTime(moment()));
          }}
          speakerHandler={() => {
            setIsAudioMute(!isAudioMute);
            playing ? pauseAudio() : playAudio();
          }}
          served={served.toString()}
          points={points.toString()}
        />

        <div className="reaction-section">
          <div className="inner-section">
            <div className="line-divider" />
            <div
              className={`row content-section ${isDemo && [0, 9].includes(demoStep) ? "scale-some" : ""
                }`}
            >
              {burgerQueue.map((item, index) => {
                return (
                  <div className="col-3">
                    <DisplayItem
                      className="will-glow"
                      index={index}
                      burger={item.burger}
                      pushedTime={item.pushedTime}
                      expectedEndTime={item.expectedEndTime}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Burger Tray */}
        <div className="fixed-section">
          {(!isDemo || (isDemo && demoStep >= 1)) && (
            <div
              className={`burger-tray-style ${isDemo && [4, 8, 9].includes(demoStep) ? "scale-some" : ""
                }`}
            >
              <div className="inner-style">
                <div className="row burger-on-tray-row">
                  {burgerTray.map((item, index) => (
                    <div className="col-4">
                      <BurgerOnTray
                        index={index}
                        ingredients={item.ingredients}
                        discountPoint={item.discountPoint}
                      />
                    </div>
                  ))}
                </div>

                <div className="sauce-icon">
                  <img src={sauce} alt="" />
                </div>
              </div>
            </div>
          )}

          <div className={`cooked-section`}>
            {/* Grill Station */}
            {(!isDemo || (isDemo && demoStep >= 2)) && (
              <ReadyTray
                className={
                  isDemo && [5, 6, 7].includes(demoStep) ? "scale-some" : ""
                }
              />
            )}
            {/* Ingredients Tray */}
            {(!isDemo || (isDemo && demoStep >= 3)) && (
              <TrayCard
                className={
                  isDemo && [4, 5, 7, 8].includes(demoStep) ? "scale-some" : ""
                }
              />
            )}
          </div>
        </div>

        {isMobile && <MyPreview generator={generatePreview} />}
      </DndProvider>

      <audio controls autoplay loop className="audio-hide" ref={AudioRef}>
        <source src={gameMusic} type="audio/mp3" />
      </audio>

      {/* <WellDoneModal
        isModalVisible={confirmModal}
        title="Are you sure!"
        description="Do you really want to remove this item?"
      /> */}

      {/* TUTORIAL / DEMO Things */}
      {isDemo == true && (
        <div
          className={`tutorial-overlay ${demoStep > 9 ? "display-dim" : ""}`}
        >
          {/* <button onClick={finishTutorial}>Skip Tutorial</button> */}
          <div className="text-light">{demoStep}</div>

          <OnboardingPopup
            description={DEMO_STEPS_DESC[demoStep]}
            className="main-onboarding-popup"
          />

          <div className="stepBtns">
            {demoStep <= 9 && (
              <>
                <div className="button-container">
                  <button
                    className="btn text-light step-btn"
                    onClick={() => setDemoStep(demoStep - 1)}
                  >
                    &lt; <span>Prev</span>
                  </button>
                  <button
                    className="btn text-light step-btn"
                    onClick={() => setDemoStep(demoStep + 1)}
                  >
                    <span>Next</span> &gt;
                  </button>
                </div>
                {/* <button className="btn text-light skip-btn">
              Skip &gt;
            </button> */}
              </>
            )}

            {demoStep > 9 && (
              <div>
                <div className="text-light font-16 last-text">
                  The More you deliver, the more Points you gain!
                </div>
                <ButtonPrimary
                  buttonText="Start Game"
                  onClickHandler={() => finishTutorial()}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default Main;
